(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
}(function () { 'use strict';

  function initAnimations() {
    setTimeout(() => {

      const root_classes = ['body:is(.page, .single-demo) .entry-content > *'];
      const child_classes = [];

      root_classes.forEach((rootClassName) => {
        document.querySelectorAll(rootClassName).forEach(el => {

          if (el.classList.contains('animation--none')) {
            return;
          }

          el.classList.add('root-animation');
          child_classes.forEach((i) => {
            el.querySelectorAll(i).forEach((f) => f.classList.add('inner-animation'));
          });
        });
      });

      document.querySelectorAll('.root-animation')
        .forEach((root) => {
          basicScroll.create({
            elem: root,
            from: 'top-bottom',
            to: 'top-middle',
            direct: true,
            timing: 'circInOut',
            props: {
              '--root--fade': {
                from: 0,
                to: 1
              },
              '--root--scroll--top': {
                from: 3,
                to: 0
              },
            }
          }).start();

          basicScroll.create({
            elem: root,
            from: 'middle-top',
            to: 'bottom-top',
            direct: true,
            timing: 'circInOut',
            props: {
              '--root--scroll': {
                from: 0,
                to: -3
              },
            }
          }).start();

          root.querySelectorAll('.inner-animation').forEach((child, index) => {
            basicScroll.create({
              elem: child,
              from: 'top-middle',
              to: 'middle-top',
              direct: true,
              timing: 'circInOut',
              props: {
                // '--child--fade': {
                //     from: 0,
                //     to: 1
                // },
                '--child--scroll-top': {
                  from: 0,
                  // to: (index + 1) * -1.5 + index * .25
                  to: -1.5
                },
              }
            }).start();
          });
        });

    }, 1500);

    const header = document.querySelector('.header');
    if (header) {
      header.classList.add('ready');
    }

    const body = document.querySelector('body');
    if (body) {
      body.classList.add('ready');
    }

  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
  }

  const CURRENT_VERSION = 1; // Used this to invalidate old cookies.
  const COUNTRY_COOKIE = 'geo-country';
  const COOKIE_EXPIRATION_DAYS = 30;
  const API_KEY = window['WEBSITE_SETTINGS'] && window['WEBSITE_SETTINGS'].IP_API_KEY || null;

  async function getCountry() {
    const {country} = await getGeoLocation();
    return country;
  }

  async function getState() {
    const {state} = await getGeoLocation();
    return state;
  }

  /**
   * Functions
   */

  function getGeoLocation() {
    const cache = loadDataFromCookies();

    return new Promise((resolve, reject) => {
      if (cache) {
        // console.log('User country from Cookies', cache);
        return resolve(cache);
      }

      if (!API_KEY) {
        return reject('IP-API key is not set.');
      }

      const endpoint = 'https://pro.ip-api.com/json/?fields=status,message,country,countryCode,regionName&key=' + API_KEY;

      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          const response = JSON.parse(this.responseText);
          if (response.status !== 'success') {
            console.log('GEO-IP query failed: ' + response.message);
            return reject(response.message);
          }

          const output = {
            country: response.country,
            countryCode: response.countryCode,
            state: response.regionName
          };

          // console.log('User GEO Data', output);
          saveDataToCookies(output); // We write cookie only before redirection.

          resolve(output);
        }
      };

      xhr.open('GET', endpoint, true);
      xhr.send();
    });
  }

  function loadDataFromCookies() {
    try {
      const cookieData = getCookie(COUNTRY_COOKIE);
      if (!cookieData) {
        return null; // No cookie found.
      }

      const data = JSON.parse(cookieData);
      if (data.version !== CURRENT_VERSION) {
        return null;
      }

      return data;
    } catch (e) {
      return null;
    }
  }

  function saveDataToCookies(output) {
    const data = {...output}; // Create a copy of the object.

    data.version = CURRENT_VERSION;
    setCookie(COUNTRY_COOKIE, JSON.stringify(data), COOKIE_EXPIRATION_DAYS); // We write cookie only before redirection.
  }

  function initHubspot($) {
    $.fn.notifyHubspot = function () {
      function doEvent(obj, name) {
        try {
          const event = new Event(name, {target: obj, bubbles: true});
          return obj ? obj.dispatchEvent(event) : false;
        } catch (e) {
          const event = document.createEvent('Event');
          event.initEvent(name, true, true);
          obj.dispatchEvent(event);
        }
      }

      $(this).each(function () {
        doEvent(this, 'change');
        doEvent(this, 'input');
        doEvent(this, 'blur');
      });

      $(this).focus();
      $(this).blur();

      return $(this);
    };
  }

  /**
   * Listen for HubSpot form ready event and execute callback.
   * @param cb - Callback function to execute when the form is ready.
   * @param formId - Optional form ID to filter the event by specific form.
   * @param eventName - Optional event name to filter the event by specific event.
   */
  function onFormReady(cb, formId = null, eventName = 'onFormReady') {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === eventName) {
        if (formId && event.data.id !== formId) {
          return;
        }

        cb(event.data.id);
      }
    });
  }

  function prepopulateURLField($) {
    let title = document.title;
    const yoastTag = document.querySelector('.yoast-seo-meta-tag[property="og:title"]');
    if (yoastTag) {
      title = yoastTag.content;
    }

    onFormReady(() => {
      const forms = document.querySelectorAll('.hs-form-' + event.data.id);
      forms.forEach(function (form) {
        updateTitleField(form);
      });
    });

    function updateTitleField(form) {
      const conversionURLField = form.querySelector("input[name='conversion_page_url']");
      if (!conversionURLField) {
        return;
      }

      $(conversionURLField).val(title).notifyHubspot();
    }
  }

  function prepopulateGeoIPCountryField($) {
    const countrySelector = 'input[name="ip_country_forms"]';
    const stateSelector = 'input[name="ip_state_forms"]';

    onFormReady(async () => {
      const country = await getCountry();
      if (country) {
        $(countrySelector).val(country).notifyHubspot();
      }

      const state = await getState();
      if (state) {
        $(stateSelector).val(state).notifyHubspot();
      }
    });
  }

  function pageScroll($) {
    const docElem = $(document.documentElement);

    const data = {
      pageHeight: docElem.height(),
      scrollTriggerPosition: function () {
        return this.pageHeight * 0.35; // 35% of the page height
      },
    };

    $(window).on('scroll', () => {
      const currentScrollPosition = $(window).scrollTop();
      $('body').toggleClass('page-scrolled', currentScrollPosition > data.scrollTriggerPosition());
    });

    $(window).on('resize', () => {
      data.pageHeight = docElem.height();
    });
  }

  // import {initEmailVerification} from "./email-verification.js";

  /*
   * Custom
   */

  (function ($) {

    /**
     * Init
     */

    try {
      initAnimations();
      initHubspot($);
      prepopulateURLField($);
      prepopulateGeoIPCountryField($);
      pageScroll($);
      // initEmailVerification();
    } catch (err) {
      console.error(err);
    }

  })(window.jQuery);

}));
